module.exports = __webpack_public_path__ + "static/media/icon-address.a1545b64.webp";